import clsx from 'clsx'
import { Leva } from 'leva'

import { useDebug } from '@hooks'
import { useMainControls } from '@utils'

export function GUI() {
  const debug = useDebug()
  useMainControls()

  return (
    <div
      className={clsx(
        'pointer-events-none absolute top-15 bottom-0 left-0 z-9999 w-83 overflow-x-hidden overflow-y-auto opacity-90 **:pointer-events-auto',
        {
          hidden: !debug,
        },
      )}
    >
      {/* See https://github.com/pmndrs/leva/issues/552 */}
      <Leva
        hidden={!debug}
        collapsed
        fill
        flat
        titleBar={{ drag: false }}
        theme={{ colors: { elevation2: '#242424' } }}
      />
    </div>
  )
}
